import { MenuEntry, WarningIcon } from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'

const config: (t: ContextApi['t']) => MenuEntry[] = (t) => [
  {
    label: t('Home'),
    icon: 'HomeIcon',
    href: '/',
  },
  // {
  //   label: t('Exchange'),
  //   icon: 'ExchangeIcon',
  //   href: '/swap'
  // },
  // {
  //   label: t('Liquidity'),
  //   icon: 'LiquidityIcon',
  //   href: '/liquidity'
  // },
  // {
  //   label: t('Farms'),
  //   icon: 'FarmIcon',
  //   href: '/farms',
  // },
  {
    label: t('Pools'),
    icon: 'PoolIcon',
    href: '/pools',
  },
  // {
  //   label: t('Referrals'),
  //   icon: 'ReferralsIcon',
  //   href: '/referrals',
  // },
  // {
  //   label: t('Prediction'),
  //   icon: 'PredictionsIcon',
  //   status: {
  //     color: 'binance',
  //     text: 'Coming'
  //   },
  //   href: '#',
  // },
  // {
  //   label: t('Lottery'),
  //   icon: 'TicketIcon',
  //   href: '/lottery',
  // },
  // {
  //   label: t('Collectibles'),
  //   icon: 'NftIcon',
  //   href: '/collectibles',
  // },
  // {
  //   label: t('Team Battle'),
  //   icon: 'TeamBattleIcon',
  //   href: '/competition',
  // },
  // {
  //   label: t('Teams & Profile'),
  //   icon: 'GroupsIcon',
  //   items: [
  //     {
  //       label: t('Leaderboard'),
  //       href: '/teams',
  //     },
  //     {
  //       label: t('Task Center'),
  //       href: '/profile/tasks',
  //     },
  //     {
  //       label: t('Your Profile'),
  //       href: '/profile',
  //     },
  //   ],
  // },
  // {
  //   label: t('Info'),
  //   icon: 'InfoIcon',
  //   href: 'https://pancakeswap.info',
  // },
  // {
  //   label: t('IFO'),
  //   icon: 'IfoIcon',
  //   status: {
  //     color: 'binance',
  //     text: 'Coming'
  //   },
  //   // href: '/ifo',
  //   href: '#',
  // },
  {
    label: t('More'),
    icon: 'MoreIcon',
    items: [
      {
        label: t('Contact'),
        href: 'https://t.me/birbdefi',
      },
      // {
      //   label: t('Voting'),
      //   href: '/voting',
      // },
      {
        label: t('Github'),
        href: 'https://github.com/birbdev',
      },
      // {
      //   label: t('Docs'),
      //   href: 'https://docs.pancakeswap.finance',
      // },
      {
        label: t('Blog'),
        href: 'https://medium.com/birb',
      },
      {
        label: t('Instagram'),
        href: 'https://www.instagram.com/birbdefi/',
      },
    ],
  },
]

export default config
